import {
  productTypeAccessory,
  productTypePackage,
  productTypeTire,
  productTypeWheel,
} from "../../constants/productTypes";
import { ToastTypeError, ToastTypeInfo } from "../../stores/slices/toastSlice";
import { Translations } from "./en";

// NOTE: Canadian French

export const fr: Translations = {
  translation: {
    aoda: {
      buttonLabel: {
        addCustomPart: "Bouton pour ajouter une pièce personnalisée",
        addLineItemToCart: "Bouton pour ajouter un article au panier",
        addToQuote: "Bouton pour ajouter à l'offre",
        addVehicles: "Ajouter des véhicules",
        backToQuote: "Bouton pour retourner à l'offre",
        backToSearchResults: "Bouton pour retourner aux résultats de recherche",
        backToStore: "Bouton pour retourner au magasin",
        backToSubmodelList: "Retourner à la liste des sous-modèles",
        calculatorMode: "Bouton pour passer en mode calculatrice",
        cancelPasswordReset:
          "Bouton pour annuler la réinitialisation du mot de passe",
        carouselControl: "Bouton pour sélectionner un élément du carrousel",
        checkNationalStock: "Bouton pour vérifier le stock national",
        checkNationalStockRear:
          "Bouton pour vérifier le stock national arrière",
        clearCartAndContinue: "Bouton pour vider le panier et continuer",
        clearCriteria: "Bouton pour effacer les critères",
        clearTireSizeInput: "Bouton pour effacer la saisie de taille de pneu",
        closeDialog: "Bouton pour fermer la boîte de dialogue",
        closeErrorToast: "Bouton pour fermer la notification d'erreur",
        closeFiltersPanel: "Bouton pour fermer le panneau de filtres",
        closeInfoToast: "Bouton pour fermer la notification d'information",
        closeSignInDialog:
          "Bouton pour fermer la boîte de dialogue de connexion",
        closeSignUpDialog:
          "Bouton pour fermer la boîte de dialogue d'inscription",
        closesNewQuoteDialog:
          "Bouton pour fermer la boîte de dialogue de nouvelle offre",
        closesOrderDialog:
          "Bouton pour fermer la boîte de dialogue de commande",
        contactDealerSubmitButton:
          "Bouton pour soumettre le formulaire de contact du concessionnaire",
        contactDealerSuccessButton:
          "Bouton pour contacter de nouveau le concessionnaire",
        copyPackage: "Bouton pour copier le paquet",
        createNewQuote: "Bouton pour créer une nouvelle offre",
        createPackage: "Bouton pour créer un package",
        dealerGroupLogo: "Logo du groupe de concessionnaires",
        deletePackage: "Bouton pour supprimer le paquet",
        editPackage: "Bouton pour modifier le paquet",
        hamburder: "Bouton de menu principal",
        homepageLink: "Bouton pour revenir à la page d'accueil",
        leadFormPrimaryAction: "Action principale du formulaire de lead",
        leadFormSecondaryAction: "Action secondaire du formulaire de lead",
        moreResults: "Bouton pour charger plus de résultats",
        myLeadsTabButton: "Bouton pour ouvrir l'onglet Mes Leads",
        myOrdersTabButton: "Bouton pour ouvrir l'onglet Mes Commandes",
        myQuotesTabButton: "Bouton pour ouvrir l'onglet Mes Offres",
        openBookingSystem:
          "Bouton pour ouvrir le système de réservation dans une nouvelle fenêtre",
        openCMS: "Bouton pour ouvrir le CMS dans une nouvelle fenêtre",
        openCartPreview: "Bouton pour ouvrir l'aperçu du panier",
        openDealerContactForm:
          "Bouton pour ouvrir le formulaire de contact du concessionnaire",
        openDownloadDialog:
          "Bouton pour ouvrir la boîte de dialogue de téléchargement",
        openEmailDialog: "Bouton pour ouvrir la boîte de dialogue d'email",
        openFiltersPanel: "Bouton pour ouvrir le panneau de filtres",
        openHowtoVideos: "Bouton pour ouvrir les vidéos d'instruction",
        openMyLeadsDialog: "Bouton pour ouvrir la boîte de dialogue Mes Leads",
        openMyOrderDialog:
          "Bouton pour ouvrir la boîte de dialogue Ma Commande",
        openMyQuotesDialog:
          "Bouton pour ouvrir la boîte de dialogue Mes Offres",
        openOrderDialog: "Bouton pour ouvrir la boîte de dialogue de commande",
        openPackageEditor: "Ouvrir l'éditeur de paquets",
        openPrintDialog: "Bouton pour ouvrir la boîte de dialogue d'impression",
        openSearchResultsInANewWindow:
          "Bouton pour ouvrir les résultats de recherche dans une nouvelle fenêtre",
        openSignInDialog:
          "Bouton pour ouvrir la boîte de dialogue de connexion",
        openTireCompareDialog:
          "Bouton pour ouvrir la boîte de dialogue de comparaison de pneus",
        openUserMenu: "Bouton pour ouvrir le menu utilisateur",
        placeOrder: "Bouton pour passer la commande",
        pricingAnalysisSearch: "Bouton pour rechercher des analyses de prix",
        quoteAction: "Bouton d'action pour l'offre",
        removeFromCompare: "Bouton pour retirer de la comparaison",
        removeFromQuote: "Bouton pour retirer de l'offre",
        removeItemFromCart: "Bouton pour retirer un article du panier",
        removeLineItemFromCart:
          "Bouton pour retirer un article de ligne du panier",
        resetLeadForm: "Bouton pour réinitialiser le formulaire de lead",
        saveQuote: "Bouton pour sauvegarder l'offre",
        searchByChassis: "Bouton pour rechercher par châssis",
        searchByPartNubmer: "Bouton pour rechercher par numéro de pièce",
        searchByTireSize: "Bouton pour rechercher par taille de pneu",
        searchByVehicle: "Bouton pour rechercher par véhicule",
        searchDealers: "Bouton pour rechercher des concessionnaires",
        selectAllVehicles: "Bouton pour Sélectionner Tous les Véhicules",
        selectNoneVehicles: "Bouton pour Ne Sélectionner Aucun Véhicule",
        selectSeason: "Bouton pour sélectionner la saison",
        selectSubmodel: "Bouton pour sélectionner le sous-modèle",
        selectTireSize: "Bouton pour sélectionner la taille de pneu",
        selectYear: "Bouton pour sélectionner l'année",
        sendRequest: "Bouton pour envoyer la demande",
        showBookAppointmentDialog:
          "Bouton pour afficher la boîte de dialogue de prise de rendez-vous",
        showCalclator: "Bouton pour afficher la calculatrice",
        showEmailField: "Bouton pour afficher le champ d'email",
        showMap: "Bouton pour afficher la carte",
        showNewQuoteModal:
          "Bouton pour afficher la nouvelle boîte de dialogue d'offre",
        showParts: "Bouton pour afficher les pièces",
        showTelField: "Bouton pour afficher le champ de téléphone",
        signOut: "Bouton pour se déconnecter",
        stockRecordLink: "Lien vers l'enregistrement de stock",
        submitDealerForm:
          "Bouton pour soumettre le formulaire de concessionnaire",
        submitPasswordresetForm:
          "Bouton pour soumettre le formulaire de réinitialisation de mot de passe",
        submitSignInForm: "Bouton pour soumettre le formulaire de connexion",
        submitSignupForm: "Bouton pour soumettre le formulaire d'inscription",
        tireStockToggle: "Basculer le stock de pneus",
        toastAction: "Bouton pour effectuer une action",
        togglePackageDetails: "Bouton pour basculer les détails du paquet",
        toggleTireCompare: "Bouton pour basculer la comparaison de pneus",
        vehicleColour: "Bouton pour sélectionner la couleur du véhicule",
        viewDetails: "Bouton pour voir les détails",
        viewResults: "Bouton pour voir les résultats",
        viewTireSizeDiagram: "Bouton pour voir le schéma de taille de pneu",
        visitDealerPage: "Bouton pour visiter la page du concessionnaire",
      },
      inputLabel: {
        advancedPricing: "Étiquette de tarification avancée",
        appointmentTime: "Heure de rendez-vous",
        brandFilter: "Filtre de marque",
        clickToSelectFile: "Cliquez pour sélectionner un fichier",
        criteria: "Critères de recherche",
        customPartName: "Nom personnalisé",
        customPartNameFr: "Nom personnalisé (français)",
        customPartNumber: "Numéro de pièce personnalisé",
        customPartPrice: "Prix personnalisé",
        customTypeName: "Type personnalisé",
        customTypeNameFr: "Type personnalisé (français)",
        dateFilter: "Filtre de date",
        distance: "Distance",
        financeAmount: "Montant du financement",
        financeInterest: "Intérêt du financement",
        financePayment: "Paiement du financement",
        financeTerm: "Durée du financement",
        packageDescription: "Description du paquet",
        packageImage: "Image du paquet",
        packageName: "Nom du Paquet",
        packageNumber: "Numéro du Paquet",
        packagePrice: "Prix du Paquet",
        partNumber: "Numéro de pièce",
        poNumber: "Numéro de bon de commande",
        postalCode: "Code postal",
        provinceFilter: "Filtre de province",
        quantity: "Quantité",
        quoteTotal: "Total du Devis",
        seasonFilter: "Filtre de saison",
        selectedChassis: "Châssis sélectionné",
        selectedDate: "Date sélectionnée",
        selectedDealer: "Concessionnaire sélectionné",
        selectedModel: "Modèle sélectionné",
        selectedProductType: "Type de produit sélectionné",
        selectedQuantity: "Quantité sélectionnée",
        selectedTireSize: "Taille de pneu sélectionnée",
        selectedTrim: "Finition sélectionnée",
        sizeFilter: "Filtre de taille",
        sortSelect: "Sélection de tri",
        tireSize: "Taille de pneu",
        username: "Nom d'utilisateur",
        vehicleManufacturerName: "Nom du fabricant du véhicule",
        vehicleYear: "Année du véhicule",
        yourEmail: "Votre e-mail",
        yourFirstName: "Votre prénom",
        yourLastName: "Votre nom",
        yourNotes: "Vos notes",
        yourPassword: "Votre mot de passe",
        yourPasswordConfirm: "Ressaisissez votre mot de passe",
        yourPhone: "Votre numéro de téléphone",
      },
      pageTitle: {
        ACCESSORIES: "Accessoires",
        ALLOY_WHEELS: "Jantes en alliage",
        PACKAGES: "Forfaits",
        TIRES: "Pneus",
        dealerCartPage: "Panier",
        dealerComparePrintPage: "Imprimer la comparaison des pneus",
        dealerContactUsPage: "Contactez-nous",
        dealerHomePage: "Page d'accueil",
        dealerProductDetailsPage: "Infos Produit",
        dealerResultsPage: "Résultats de recherche",
        dealerWishlistPrintPage: "Imprimer le panier",
        nationalVendorLandingPage: "Cabine d'essayage",
        nationalVendorPage: "Recherche de concessionnaire",
        packageEditor: "Éditeur de paquets",
      },
    },
    auth: {
      accountCreated: "Compte créé. Veuillez vous connecter.",
      cancel: "Annuler",
      createAccount: "Créer un compte",
      failedToSignIn: "Échec de la connexion, veuillez réessayer.",
      forgotPassword: "Mot de passe oublié?",
      lickToRegister: "Cliquez pour vous inscrire",
      myLeads: "Mes prospects",
      myOrders: "Mes commandes",
      myQuotes: "Mes devis",
      passwordReset: "Réinit. mot de passe",
      reset: "Réinitialiser",
      signIn: "Se connecter",
      signInTitle: "Bienvenue",
      signUp: "S'inscrire",
    },
    calculator: {
      bWeekly: "Bi-hebdo",
      error: {
        positiveInteger:
          "La durée doit être un nombre entier (sans décimales).",
        positiveNumber: "Veuillez saisir un nombre égal ou supérieur à 0.",
      },
      month_one: "mois",
      month_other: "mois",
      monthly: "Mensuel",
      placeHolderAmount: "Montant du financement",
      placeholderInterest: "Taux d'intérêt",
      placeholderMonths: "Nombre de mois",
      placeholderWeeks: "Nombre de semaines",
      week_one: "semaine",
      week_other: "semaines",
    },
    captcha: {
      robotCheck: "Vérification robot",
    },
    cart: {
      add: "Ajouter",
      addItem: "Ajouter un produit",
      addToQuote: "Ajouter au panier",
      address: "Adresse",
      appointmentRequestDisclaimer:
        "La demande de rendez-vous est uniquement une demande et non un rendez-vous confirmé – Notre service vous contactera dans les 24 heures pour confirmer un rendez-vous.",
      backToStore: "Retour à la boutique",
      bookAppointment: "Prendre rendez-vous",
      cancel: "Annuler",
      contactDealer: "Contacter le concess",
      contactDealerForPricing: "Contacter le concess. pour les prix",
      contactInformation: "Information de contact",
      continue: "Continuer",
      createNewQuote: "Créer un nouveau devis",
      customerEmail: "Mail client",
      customerName: "Nom du client",
      customerNotes: "Notes",
      customerPhone: "Tél. client",
      date: "Date",
      dealerAddress: "Adr. concessionnaire",
      dealerEmail: "Mail concessionnaire",
      dealerName: "Nom du concessionnaire",
      dealerPhone: "Tél. concessionnaire",
      generateQuote: "Demander une estimation",
      header: { order: "Votre commande", quote: "Votre devis personnalisé" },
      newQuote: "Nouveau devis",
      newQuoteModalContent:
        "Vous serez dirigé pour commencer une nouvelle session d'achat.",
      noOrders: "Aucune commande ici, essayez d'en ajouter!",
      notAvailable: "N/A",
      notes: "Notes",
      ok: "OK",
      orderCreatedTimestamp: "Créé le",
      orderCreatedUserName: "Créé par",
      orderNow: "Commander maintenant",
      packageCreatedMessage:
        "Pneus dans le panier. Veuillez choisir les roues ensuite.",
      price: "Prix",
      quantity: "Quantité",
      reference: "Référence",
      remove: "Retirer",
      removeFromQuote: "Retirer du panier",
      requestAppointment: "Demander un rendez-vous",
      saveQuote: "Enregistrer le devis",
      subtotal: "Sous-total",
      tax: "Taxe",
      thankYourForChoosing: "Merci d'avoir choisi",
      timeOptions: {
        am: "matin",
        pm: "après-midi",
      },
      total: "Total",
      totalPrice: "Prix total",
      viewDetails: "Voir les détails",
      xTimeAppointmentDialogSubtitle:
        "Calendrier de rendez-vous - Pour assurer la disponibilité des pneus, veuillez réservez un rendez-vous dans un délai de 24 heures à compter d'aujourd'hui.",
      xTimeAppointmentDialogTitle: "Prendre rendez-vous",
      xTimeAppointmentHeadline: "Choisissez un rendez-vous avec {{dealerName}}",
      xTimeAppointmentNodata:
        "Impossible de charger le formulaire de rendez-vous",
      yourOrder: "Votre commande",
      yourQuote: "Votre devis",
    },
    compare: {
      additionalCosts: "Coûts supplémentaires",
      category: "Catégorie",
      clientInformation: "Informations client",
      description: "Description",
      frontPartNumber: "N° pièce F",
      grandTotal: "Total général",
      mileageWarranty: "Garantie de kilométrage",
      moreInfo: "Plus d'informations",
      msrp: "PDSF",
      natPart: "Pièce N°",
      notAvailable: "N/A",
      originalEquipment: "Équipement d'origine",
      otherInformation: "Autre information",
      ourPrice: "Notre prix",
      partNumber: "N° de pièce",
      pricingDetails: "Détails des prix",
      pricingInformation: "Information sur les prix",
      productDetails: "Détails du produit",
      productInformation: "Information sur le produit",
      promotion: "Promotion",
      quantity: "Quantité",
      quick: "Comp. rapide",
      rearPartNumber: "N° pièce R",
      season: "Saison",
      selected: "Comp. sélectionnés",
      subtotal: "Sous-total",
      tax: "Taxe",
      tireSize: "Taille du pneu",
      total: "Total",
      warranty: "Garantie",
    },
    contactUs: {
      address: "Adresse",
      closed: "Fermé",
      email: "Courriel",
      header: "Contactez-nous",
      home: "Accueil",
      hoursHeader: "Service client de {{dealerName}}",
      hoursSubtitle: "Nos heures d'ouverture",
      phone: "Téléphone",
    },
    dealerOrderModal: {
      contactInformation: "Informations du client",
      customerNumber: "Client#",
      delivery: "Livraison",
      disclaimer:
        "Tire Wizard Inc. n'est pas responsable de l'exécution des commandes. Pour toute modification ou question concernant votre commande, veuillez contacter directement TireLink.",
      email: "Courriel",
      emailPlaceholder: "Entrez l'adresse e-mail ici",
      error: {
        customerEmail: "Veuillez entrer une adresse email valide",
        invalidResponse:
          "Commande échouée. Veuillez contacter votre revendeur.",
        poNumber: "Veuillez entrer un numéro de PO",
      },
      errorMessage:
        "Nous sommes désolés, mais nous n'avons pas reçu les données appropriées",
      estDeliveryDate: "Date Livraison",
      firstName: "Prénom",
      firstNamePlaceholder: "Entrez le prénom ici",
      freight: "Fret",
      itemInformation: "Information sur l'article",
      lastName: "Nom de famille",
      lastNamePlaceholder: "Entrez le nom de famille ici",
      loadSpeedPly: "Charge/Vitesse/Plis",
      local: "Local",
      "local+": "Local+",
      locationCode: "code de localisation#",
      natPart: "Pièce",
      national: "NTL",
      nationalPricing: "Nat",
      noData: "Désolé, vous n'avez aucun article de commande.",
      orderPreview: "Aperçu de la commande",
      paymentQty: "Qté Paiement",
      phone: "Téléphone",
      phonePlaceholder: "Entrez le numéro de téléphone ici",
      pickUp: "Ramasser",
      placeOrder: "Passer la commande",
      poPlaceholder: "Entrez le numéro de PO",
      quantity: "{{from}} de {{to}}",
      remove: "Retirer",
      sourcedQty: "Qté Approvisionnée",
      subtotal: "Sous-total",
      successMessage: "Commande confirmée. ID #{{orderNumber}}.",
      tireSize: "Taille du pneu",
      total: "Total",
      unitCost: "Coût Unité",
      withOtherGoods: "Avec d'autres marchandises",
    },
    dealerProducts: {
      [productTypeAccessory]: "Accessoires",
      [productTypePackage]: "Forfaits",
      [productTypeTire]: "Pneus",
      [productTypeWheel]: "Roues",
    },
    dealerTireTile: {
      availableStock: "Stock disponible",
      compare: "Comparer",
      createPackage: "Créer un forfait",
      inLocation_one: "disponible à travers {{count}} entrepôt",
      inLocation_other: "disponibles à travers {{count}} entrepôts",
      other: "Autre",
      tires_one: "{{displayCount}} pneu",
      tires_other: "{{displayCount}} pneus",
    },
    error: {
      boundary: {
        heading: "Quelque chose s'est détraqué",
        message: "De retour sur les rails bientôt",
      },
    },
    form: {
      error: {
        appointmentRequestDate: "Veuillez sélectionner une date",
        appointmentRequestTime: "Veuillez sélectionner une heure",
        customName: "Veuillez entrer un nom personnalisé",
        customNameFr: "Veuillez entrer un nom personnalisé (Français)",
        customPartNumber: "Veuillez entrer un numéro de pièce personnalisé",
        customPrice: "Veuillez entrer un prix",
        customTypeName: "Veuillez entrer un nom de type personnalisé",
        customTypeNameFr:
          "Veuillez entrer un nom de type personnalisé (Français)",
        customerEmail: "Veuillez entrer une adresse email valide",
        customerFirstName: "Veuillez entrer votre prénom",
        customerLastName: "Veuillez entrer votre nom de famille",
        customerPhone: "Veuillez entrer un numéro de téléphone valide",
        email: "Veuillez entrer une adresse e-mail valide",
        invalidDate: "Veuillez entrer une date valide",
        lineItemNotes: "Veuillez entrer une note",
        lineItemPrice: "Veuillez entrer une remise",
        name: "Veuillez entrer votre nom",
        packageDescription: "Veuillez saisir une description de paquet",
        packageName: "Veuillez saisir un nom de paquet",
        packageNumber: "Veuillez saisir un numéro de paquet",
        packagePrice: "Veuillez saisir un prix de paquet",
        packageQuantity: "Veuillez entrer une quantité entre 1 et 16",
        partNumber: "Veuillez entrer un numéro de pièce",
        password: "Veuillez entrer votre mot de passe",
        passwordMismatch: "Les mots de passe ne correspondent pas",
        postalCode:
          "Le code postal doit être un code postal américain ou canadien valide",
        pricePrecision:
          "Le prix doit avoir jusqu'à 2 chiffres après la virgule.",
        tel: "Veuillez entrer un numéro de téléphone valide",
        tireSize: "Veuillez entrer la taille du pneu",
        username: "Veuillez entrer une adresse email valide",
        vehicleManufacturerIds: "Veuillez sélectionner un fabricant",
        vehicleYearIds: "Veuillez sélectionner une année",
      },
      label: {
        add: "Ajouter",
        appointmentRequestDate: "Date de rendez-vous préférée",
        appointmentRequestTime: "Heure de contact préférée",
        cancel: "Annuler",
        customerEmail: "Courriel du client",
        discount: "Rabais",
        email: "Email",
        firstName: "Prénom",
        lastName: "Nom de famille",
        name: "Nom",
        note: "Message (Note)",
        notes: "Notes",
        optionalMessage: "Message (Facultatif)",
        password: "Mot de passe",
        passwordConfirm: "Confirmer le mot de passe",
        phoneNumber: "Numéro de téléphone",
        priceMatchNotes: "Notes de correspondance des prix",
        tel: "Téléphone",
        username: "Adresse e-mail",
        workOrderNumber: "Numéro de bon de commande",
      },
      placeholder: {
        email: "Entrez l'adresse e-mail",
        firstName: "Entrez votre prénom",
        lastName: "Entrez votre nom de famille",
        name: "Entrez le nom",
        notes: "Entrez les notes",
        optionalMessage: "Entrez le message",
        password: "Entrez le mot de passe",
        phoneNumber: "Entrez votre numéro de téléphone",
        tel: "Entrez le numéro de téléphone",
        username: "Entrez votre courriel",
      },
    },
    header: {
      contactUs: "Contactez-nous",
    },
    heroWheels: {
      guarantee: "Garantie",
      lowestPrice: "Prix le plus bas",
      tireSource: "Source de pneus",
    },
    leadForm: {
      button: {
        download: {
          primary: "Télécharger & courriel",
          secondary: "Télécharger",
        },
        email: {
          primary: "Envoyer",
        },
        print: {
          primary: "Imprimer & courriel",
          secondary: "Imprimer",
        },
        "save-quote": {
          primary: "Enregistrer",
        },
      },
      compare: {
        subtitle: {
          download:
            "Remplissez le formulaire ci-dessous pour télécharger cette comparaison.",
          email:
            "Remplissez le formulaire ci-dessous pour envoyer cette comparaison.",
          print:
            "Remplissez le formulaire ci-dessous pour imprimer cette comparaison.",
        },
        title: {
          download: "Télécharger",
          email: "Envoyer",
          print: "Imprimer",
        },
      },
      download: "Télécharger",
      email: "Courriel",
      order: {
        subtitle: {
          download:
            "Télécharger la commande en PDF et envoyer éventuellement un courriel.",
          email:
            "Remplir le formulaire pour envoyer cette commande par courriel au client.",
          print:
            "Imprimer votre commande et envoyer éventuellement un courriel.",
        },
        title: {
          download: "Télécharger la Commande",
          email: "Commande par Courriel",
          print: "Imprimer la Commande",
          save: "Sauvegarder la Commande",
        },
      },
      print: "Imprimer",
      quote: {
        subtitle: {
          download:
            "Télécharger le devis en PDF et envoyez un courriel si nécessaire.",
          email: "Remplissez le formulaire pour envoyer un courriel au client.",
          print: "Imprimez le devis et envoyez un courriel si nécessaire.",
        },
        title: {
          download: "Télécharger le devis",
          email: "Envoyer",
          print: "Imprimer le devis",
          save: "Enregistrer le devis",
        },
      },
      successMessage: "Votre demande a été envoyée.",
    },
    leadReport: {
      createdDate: "Date créer (mise à jour)",
      customerEmail: "Courriel du client",
      customerName: "Nom du client",
      customerNotes: "Notes",
      customerPhone: "Téléphone du client",
      generatedByActionType: "Type",
      noData: "Désolé, votre recherche n'a pas pu trouver de résultats.",
      orderId: "Numéro de la soumission",
      ownerType: "Type",
      requestedDate: "Requested Date",
      status: "Order Status",
    },
    national: {
      anyDistance: "Toute distance",
      contactDealerForPricing: "Contacter le concess. pour les prix",
      dealer: "Détaillant",
      location: "Emplacement",
      nodata: "Désolé, votre recherche n'a pas pu trouver de résultats.",
      phone: "Téléphone",
      postalCodeOrCity: "Code postal ou ville",
      redirecting: "Redirection en cours...",
      search: "Recherche",
      selectDealerForPricing: "Sélectionnez le détaillant pour les prix",
      selectDealership: "Sélectionnez un concessionnaire",
      showMap: "Afficher la carte",
      withinDistance: "à l'intérieur {{option}} km",
    },
    orderFilters: {
      "1month": "1 mois",
      "2months": "2 mois",
      "3months": "3 mois",
      "4months": "4 mois",
      "7days": "7 jours",
      all: "Tous",
      byCreatedAscending: "Par ordre ascendant de création",
      byCreatedDescending: "Par ordre décroissant de création",
      byCustomerNameAscending: "Par nom du client ordre ascendant",
      byCustomerNameDescending: "Par nom du client ordre décroissant",
      byLeastRecent: "Les moins récentes",
      byMostRecent: "Les plus récentes",
      byTotalPriceAscending: "Par prix total ordre ascendant",
      byTotalPriceDescending: "Par prix total ordre décroissant",
      search: "Recherche",
      show: "Afficher",
      size: "Limite",
      sort: "Trier",
      today: "Aujourd'hui seulement",
      typeToSearch: "Tapez pour rechercher",
      yesterday: "Hier",
    },
    orderReport: {
      confirmationNumber: "Numéro de confirmation",
      createdBy: "Créer par",
      customerEmail: "Courriel du client",
      customerName: "Nom du client",
      customerNotes: "Notes",
      customerPhone: "Téléphone du client",
      dateCreated: "Date créer (mise à jour)",
      deliveryStatus: "Statut de la livraison",
      orderNumber: "Numéro de commande",
      orderTotal: "Order Total",
      poNumber: "Numéro de PO",
      type: "Type",
      viewOrders: "Afficher les commandes",
    },
    packageEditor: {
      actionsDetails: "Actions/Détails",
      addCustomPart: "Ajouter une pièce personnalisée",
      addVehicles: "Ajouter des véhicules",
      advancedPricing: "Tarification avancée",
      brandIcon: "Icône de marque",
      close: "Fermer",
      copyPackage: "Copier le paquet",
      cost: "Coût",
      createPackage: "Créer un paquet",
      createQuote: "Créer un devis",
      customName: "Nom (anglais)",
      customNameFr: "Nom (français)",
      customPrice: "Prix",
      customTypeName: "Type (Anglais)",
      customTypeNameFr: "Type (Français)",
      deletePackage: "Supprimer le paquet",
      edit: "Modifier",
      editPackage: "Modifier le paquet",
      fetchVehicles: "Récupérer les véhicules",
      info: "Infos",
      invalidQuoteNotice:
        "Veuillez ajouter au moins une partie à la citation pour créer un ensemble.",
      myPrice: "Mon prix",
      nationalSuggestedRetail: "Prix de détail national suggéré",
      newPackage: "Nouveau Paquet",
      next: "Suivant",
      noData: "Aucun paquet ici, veuillez en créer.",
      noVehiclesSelected: "Veuillez sélectionner au moins un véhicule.",
      noWheelPart: "Désolé, ce paquet n'a pas de pièce de roue",
      packageCopyNote:
        "Pour dupliquer «{{ packageName }}», nous créerons une nouvelle offre où vous pourrez apporter les modifications nécessaires.",
      packageCreated: "Colis créé",
      packageDeleteNote:
        "Vous êtes sur le point de supprimer définitivement le paquet : '{{ packageName }}'",
      packageDeleted: "Paquet supprimé",
      packageDescription: "Description du paquet",
      packageDescriptionFr: "Description du paquet (français)",
      packageEditor: "Éditeur de paquets",
      packageExpireDate: "Date d'expiration",
      packageImage: "Image du paquet",
      packageName: "Nom du Paquet",
      packageNumber: "Numéro du Paquet",
      packagePrice: "Prix du Paquet",
      packageReleaseDate: "Date de sortie",
      "part#": "N° de pièce",
      partNumber: "Numéro de pièce",
      partType: "Type de pièce",
      parts: "Pièces",
      price: "Prix",
      quantity: "Quantité",
      quoteTotal: "Total du Devis",
      selectAllVehicles: "Tout",
      selectNoneVehicles: "Aucun",
      selectVehicleYears:
        "Sélectionnez les années et les fabricants des véhicules",
      selected: "Sélectionné",
      showParts: "Afficher les pièces",
      typeName: "Type",
      updatePackage: "MàJ le paquet",
      vehicles: "Véhicules",
    },
    pageNotFound: "Page non trouvée",
    priceSelect: {
      front: "Avant",
      price: "Prix",
      quantity: "Quantité",
      rear: "Arrière",
      savings: "Économies",
      total: "Pièce Totale",
    },
    pricingAnalysis: {
      allBrands: "Toutes les marques",
      averagePrice: "Prix moyen",
      brand: "Marque",
      costPrice: "Prix de revient",
      header: "Analyse de prix des pneus",
      minPrice: "Prix minimum",
      name: "Nom",
      noData: "Désolé, votre recherche n'a pas pu trouver de résultats.",
      openCMS: "Connectez-vous pour mettre à jour les prix",
      partNumber: "N° de pièce",
      quantityBooked: "Quantité réservée",
      quantitySold: "Quantité vendue",
      search: "Recherche",
      summary: "Résumé",
      summaryHigherThen: "{{val}} plus élevé que le prix minimum",
      summaryLowerThen: "{{val}} inférieur au prix minimum",
      tireSize: "Taille du pneu",
      yourPrice: "Votre prix",
    },
    provinceSelect: {
      AB: "Alberta",
      BC: "Colombie-Britannique",
      MB: "Manitoba",
      NB: "Nouveau-Brunswick",
      NL: "Terre-Neuve-et-Labrador",
      NS: "Nouvelle-Écosse",
      NT: "Territoires du Nord-Ouest",
      NU: "Nunavut",
      ON: "Ontario",
      PE: "Île-du-Prince-Édouard",
      QC: "Québec",
      SK: "Saskatchewan",
      YT: "Yukon",
      viewAll: "Toute Province",
    },
    quoteReport: {
      createdBy: "Créer par",
      customerEmail: "Courriel du client",
      customerName: "Nom du client",
      customerNotes: "Notes",
      customerPhone: "Téléphone du client",
      dateCreated: "Date créer (mise à jour)",
      details: "Détails",
      isDealer: "Détaillant",
      isNational: "NTL",
      noData: "Désolé, votre recherche n'a pas pu trouver de résultats.",
      notAvailable: "N/A",
      orderPrinted: "Commande Imprimé",
      priceMatch: "Prix Assorti",
      quoteNumber: "Numéro de la soumission",
      quoteTotal: "Total de la soumission",
      status: "Order Status",
      type: "Type",
      viewQuotes: "Voir la soumission",
      yes: "Oui",
    },
    searchForm: {
      chassis: "Châssis",
      enterPartNumber: "Entrez le numéro de pièce",
      enterPostalCode: "Entrez le code postal",
      enterTireSize: "Entrez la taille de pneu",
      partNubmer: "Pièce N°",
      searchByPartNubmer: "Recherche par N° de pièce",
      searchByTireSize: "Recherche par taille de pneu",
      searchByVehicle: "Recherche par véhicule",
      selectLocation: "Sélectionnez l'emplacement",
      selectMake: "Sélectionnez la marque",
      selectModel: "Sélectionnez le modèle",
      selectProductType: "Sélectionnez le type de produit",
      selectTrim: "Sélectionnez la finition",
      selectYear: "Sélectionnez l'année",
      tireSize: "Taille de pneu",
      vehicle: "Véhicule",
      vehicleChassisPlaceholder: "w204 ou w204.012",
      viewResults: "Voir les résultats",
    },
    searchResults: {
      accessoryHint: "Voici quelques accessoires pour votre voiture",
      axiePartner: "Partenaire Axie",
      backToContact: "Retour au contact",
      backToQuote: "Retour au devis",
      backToResults: "Retour aux résultats",
      categories: "Catégories",
      checkNationalStock: "Inventaire",
      checkNationalStockFront: "Avant",
      checkNationalStockRear: "Arrière",
      color: "Couleur",
      contactDealer: "Contacter le concess.",
      contactMethod: "Veuillez me contacter via",
      dealerFormDescription:
        "Laissez vos coordonnées ici afin que nous puissions vous contacter rapidement.",
      description: "Description",
      diameter: "Ø jante",
      email: "Courriel",
      filters: "Filtres",
      filtersSubtitle: "Sélectionnez et appliquez les filtres décrits",
      front: "Avant",
      installation: "Installation",
      installationRequired: "Installation requise",
      leadSuccessHeading: "Merci de nous avoir contactés&nbsp;!",
      leadSuccessMessage:
        "Vos informations ont été soumises avec succès. Nous vous recontacterons dès que possible. Merci de votre intérêt&nbsp;!",
      loadSpeedPly: "Charge/Vitesse/Plis",
      msrp: "PDSF",
      nationalStock: "Stock national",
      no: "Non",
      noData:
        "Aucun résultat trouvé, essayez un véhicule ou une taille différente.",
      noSeasons: "Saisons non disponibles",
      notes: "Notes",
      offset: "Déport",
      openInNewWindow: "Ouvrir en nouvel onglet",
      originalEquipment: "Équipement d'origine",
      originalEquipmentAll: "Tout afficher",
      originalEquipmentOnly: "Afficher les Pneus approuvés",
      packageOptions: "Options de forfait",
      packageResultsLink: "Voir les pneus disponibles",
      partDetails: "Détails de la pièce",
      partNumber: "Pièce N°",
      price: "Prix",
      pricing: "Prix du pneu",
      pricingIsNotAvailable:
        "Le prix n'est pas disponible pour cette recherche. Veuillez contacter le concessionnaire pour obtenir les tarifs.",
      pricingNote: "Note de prix",
      rear: "Arrière",
      reccommendedFor: "Recommandé pour",
      relatedParts: "Pièces connexes",
      requestMoreInformation: "Demander plus d'informations",
      requiresInstallation: "Installation requise",
      restrictions: "Restrictions",
      runFlat: "Roulage à plat",
      search: "Recherche",
      season: "Saison",
      selectWeelToPreview: "Sélectionnez une roue pour prévisualiser",
      sendRequest: "Envoyer la demande",
      showNonRunFlat: "Montrer non roulage à plat",
      showRunFlat: "Roulage à plat",
      size: "Taille",
      tel: "Téléphone",
      tireBrand: "Marques de pneus",
      tireLoadRating: "Indice de charge",
      tirePlyRating: "L'indice de capacité de charge pour véhicule utilitaire",
      tireSize: "Taille du pneu",
      tireSpeedIndex: "Indice de vitesse",
      viewDetails: "Voir les détails",
      warning: "Attention",
      warranty: "Garantie",
      wheelBrand: "Marques de roues",
      wheelVisualizerCaution:
        "Le véhicule peut ne pas apparaître exactement comme indiqué",
      wheelVisualizerHint: "Vous pouvez personnaliser la couleur de la voiture",
      width: "Largeur",
      yes: "Oui",
      yourPersonalizedQuote: "Votre devis personnalisé",
    },
    season: {
      "0": "Hiver",
      "1": "Toutes saisons",
      "2": "Été",
    },
    siteHeader: {
      bookinkSystem: "Système de réservation",
      cmsUrl: "URL du CMS",
      contactUs: "Contactez-nous",
      home: "Accueil",
      howToVideos: "Vidéos d'instruction",
      nationalSite: "Changer de lieu",
      pricingAnalysis: "Analyse prix pneus",
      signIn: "Se connecter",
      signOut: "Déconnexion",
    },
    sizeTypeDescription: {
      "Alternate Size": "Taille Alternative",
      "Down Size": "Taille Diminuer",
      "Original Size": "Taille Originale",
      "Seasonal Size": "Taille Saisonnier",
      "Temporary Size": "Taille Temporaire",
      "Up Size": "Taille Augmenter",
    },
    stockLevelsModal: {
      city: "Ville",
      distributor: "Distributeur",
      lastUpdated: "Dernière Mise à Jour",
      location: "Emplacement",
      phone: "Téléphone",
      province: "Province",
      qty: "Quantité",
    },
    tireSizeDiagram: {
      description:
        "Pour garantir une taille appropriée, contactez toujours votre centre de service de véhicule local.",
      subtitle: "Comment trouver votre taille de pneu",
      title: "Schéma de taille de pneu",
    },
    tireSizeInput: {
      price: "Prix",
      quantity: "Quantité",
      total: "Total",
    },
    toast: {
      [ToastTypeError]: "Erreur",
      [ToastTypeInfo]: "Info",
      sessionExpired: "Votre session a expiré. Veuillez vous reconnecter.",
    },
  },
};
